<template>
  <div class="employee-setting">
    <div class="authority">
      <p class="title">
        <img class="img" src="../../../../assets/images/employee/employee.png" alt />
        <span>当前人员：{{name}}</span>
      </p>
      <div>
        <div class="container">
          <div class="project" v-for="(value, index) in projectsList" :key="index">
            <el-checkbox
              class="check-all"
              :indeterminate="value.isIndeterminate"
              @change="handleCheckAllChange(index)"
              v-model="value.checkAll"
            >{{ value.checkAllName }}</el-checkbox>
            <el-checkbox-group v-model="value.checked" @change="handleCheckedProjectChange(index)">
              <el-checkbox
                :label="project.id"
                v-for="(project, projectIndex) in value.projects"
                :key="projectIndex"
              >{{ project.projectsName }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="btns">
          <el-button class="btn-white" @click="pageBack">取消</el-button>
          <el-button class="btn-blue" @click="saveEmployeeAuthority">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Employee from "models/employee";
const employee = new Employee();
export default {
  data() {
    return {
      id: "",
      name: "",
      //数组范围
      // checkAll: false,
      // checkList: [2, 4],
      // isIndeterminate: true,
      projectsList: []
    };
  },
  computed: {},
  activated() {
    this.projectsList = [];
    this.id = Number(this.$route.query.id);
    this.name = this.$route.query.name;
    this.getProjectList();
  },
  created() {
    this.projectsList = [];
    this.id = Number(this.$route.query.id);
    this.name = this.$route.query.name;
    this.getProjectList();
  },
  methods: {
    //获取列表
    getProjectList() {
      employee.getEmployeeProjects().then(res => {
        if (res.success) {
          let projectsList = [];
          res.result.map(value => {
            let obj = {};
            obj.checkAll = false;
            obj.warehouseId = value.warehouseId;
            obj.checkAllName = value.warehouseName;
            obj.isIndeterminate = false;
            obj.checked = [];
            obj.projects = value.projectsList;
            projectsList.push(obj);
          });
          this.projectsList = projectsList;
          this.employeeAuthority();
        }
      });
    },
    //获取当前用户项目权限
    employeeAuthority() {
      let employeeId = this.id;
      employee.getEmployeeAuthority(employeeId).then(res => {
        res.result.map(item => {
          this.projectsList.map((value, index) => {
            if (item.warehouseId === value.warehouseId) {
              value.checked = item.projectsList;
              this.handleCheckedProjectChange(index);
            }
          });
        });
      });
    },
    //全选
    handleCheckAllChange(index) {
      if (this.projectsList[index].checkAll) {
        let arr = [];
        this.projectsList[index].projects.map(value => {
          arr.push(value.id);
        });
        this.projectsList[index].checked = arr;
      } else {
        this.projectsList[index].checked = [];
      }
      this.projectsList[index].isIndeterminate = false;
    },
    //单个选
    handleCheckedProjectChange(index) {
      let checkedCount = this.projectsList[index].checked.length;
      this.projectsList[index].checkAll =
        checkedCount === this.projectsList[index].projects.length;
      this.projectsList[index].isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.projectsList[index].projects.length;
    },
    //保存已选项目
    saveEmployeeAuthority() {
      let data = {};
      data.employeeId = this.id;
      data.projectsIdList = [];
      this.projectsList.map(value => {
        data.projectsIdList = data.projectsIdList.concat(value.checked);
      });
      employee.postUpdateEmployeeAuthority(data).then(res => {
        if (res.success) {
          this.$message.success("设置成功");
        }
      });
    },
    //返回
    pageBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.employee-setting {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  .authority {
    .title {
      height: 32px;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 16px;
      padding-left: 16px;
      font-size: 20px;
      display: flex;
      align-items: center;
      .img {
        margin-right: 10px;
      }
    }
    .second-tit {
      padding: 0 0 16px 16px;
    }
    .container {
      min-height: 400px;
    }
    .project {
      border-top: 1px solid #eeeeee;
      margin-left: 100px;
      display: flex;
      align-items: flex-start;
      padding-top: 10px;
      padding-bottom: 10px;
      .check-all {
        width: 160px;
        margin-right: 0;
        line-height: 32px;
        display: block;
      }
      .el-checkbox-group {
        flex: 1;
        padding: 0 16px;
        .el-checkbox {
          width: 160px;
          margin-right: 0;
          line-height: 32px;
        }
      }
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
